import compact from 'lodash/compact'
import type { OperationalListItem } from '@klear/operational/operational-list.wire'
import type { PaymentLineItem } from '@klear/payment/line-item'

export type CoveredEventDetails = Map<number, OperationalListItem>

export function coveredEventDetails(operationals: OperationalListItem[]): CoveredEventDetails {
  return new Map(operationals.map((operational) => [operational.id, operational]))
}

export function coveredLineMeta(item: PaymentLineItem, details: CoveredEventDetails): string[] {
  const detail = item.orderEventId != null ? details.get(item.orderEventId) : undefined
  return compact([
    detail?.idDisplay,
    detail?.orderIdDisplay,
    detail?.customerName,
    detail?.parentIdDisplay,
    item.effectiveDate
  ])
}
